import { useState } from 'react'
import SearchBar from '@/components/SearchBar/Index'
import styles from './Navs.module.less'
import { Image } from 'antd-mobile'
import { LeftOutline } from 'antd-mobile-icons'
import { utils, apis } from '@/utils';
import { useNavigate, useSearchParams } from "react-router-dom";
import { useMount } from 'ahooks'
import iconNav from "@/assets/img/icon/nav-icon.png";
import { routesMap } from '@/router/routes';

const { px2rem, to, capitalizeFirstLetter, concatenateImageUrl } = utils
const { corpApi } = apis

interface ModuleDetails {
  [key: string]: any;
}

function Navs() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams()
  const corpId = searchParams.get('corpId')
  const corpModuleId = searchParams.get('corpModuleId')
  const [detail, setDetail] = useState<ModuleDetails[]>([])
  const [navDetail, setNavDetail] = useState<ModuleDetails[]>([])
  // const [searchText, setSearchText] = useState('')

  const onSearch = (text: string) => {
    filterNavDetail(text)
  }

  /*
  * 请求数据
  */
  async function initNav() {
    // 获取详情
    const [err, res] = await to(
      corpApi.queryHomeModuleDetail({ corpId, corpModuleId }),
    );
    if (err || !res.data) {
      return;
    }

    // 处理数据
    const detail = res.data.map((item: any) => {
      // 拼oss地址
      item.image = item.image ? concatenateImageUrl(`${item.image}_140`) : '';
      return item;
    });

    setDetail(detail)
    setNavDetail(detail);
  }
   // 根据搜索关键字筛选
  function filterNavDetail(text: string) {
    // 如果没有搜索词则显示全部
    if (!text.trim()) {
      setNavDetail(detail);
      return;
    }

    // 否则显示搜索结果
    const navDetail = detail.filter((item) => item.title.indexOf(text) >= 0);
    setNavDetail(navDetail);
  }
  /*
   * 点击跳转
  */
  function handleNavigation(index: number) {
    const item = navDetail[index];
    if (!item || !item.detail || !item.detail.dataType || !item.detail.dataValue) {
      return;
    }

    const { dataType, dataValue, sort } = item.detail;
    // 如果是货品，则跳到货品详情页
    if (dataType === 6) {
      navigate(`/product/detail/${dataValue}`);
      return;
    }

    // 否则跳到 筛选结果
    navigate(`${routesMap.CategorySearch}?dataType=${dataType}&dataValue=${dataValue}&sort=${sort}`);
  }

  const NavItem = () => {
    return navDetail.map((item: ModuleDetails, index: number) => {
      return (
        <div className={styles["nav-item"]} onClick={() => handleNavigation(index)} key={index}>
          <div className={styles["img-wrap"]}>
            <Image
              fit="cover"
              className={item.image ? styles["preview-img"] : styles["nav-img-icon"]}
              src={item.image || iconNav}
            ></Image>
          </div>
          <p className={styles["title"] + " ep-2"}>{capitalizeFirstLetter(item.title)}</p>
        </div>
      );
    });
  };

  useMount(() => {
    initNav()
  })

  return (
    <div className={styles['navs-page']}>
      <div className={styles['navs-hd']}>
        <div className={styles['searchbar-box']}>
          <LeftOutline fontSize={px2rem(28)} color='#222' onClick={() => navigate(-1)} />
          <SearchBar className={styles['search-bar']} enableSearch={true} isShowScan={false} onSearch={onSearch} />
        </div>
      </div>
      <div className={styles['navs-bd']}>
        <div className={styles['nav-wrap']}>
          <div className={styles['bd']}>
            <NavItem />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Navs
